import { SET_ANSWER, SET_QUESTION_ORDER } from '../actions/index';
import { getMatchValueArray } from '../utils';
import getLocale from '@ali/brokkoli/lib/utils/get_locale';

const getAllAnswer = () => {
  const macher = /question_right_answer/;
  const object = getLocale('page_qna');
  return getMatchValueArray(object, macher);
};

const answerLength = getAllAnswer().length;

const initialAnswer = Array(answerLength).fill(-1);
const initialQuestionOrder = getAllAnswer().map((item, index) => index);
const initState = {
  answer: initialAnswer,
  questionOrder: initialQuestionOrder,
};
function reducers(state = initState, action) {
  switch (action.type) {
    case SET_ANSWER:
      return Object.assign(state, { answer: action.data });
    case SET_QUESTION_ORDER:
      return Object.assign(state, { questionOrder: action.data });
    default: {
      return state;
    }
  }
}
export default reducers;
